var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-banner",style:({ '--height': `${_vm.height}px` })},[_c('transition',{attrs:{"name":"banner"}},[(_vm.show)?_c('div',{staticClass:"notification-banner__banner"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),_c('close-button',{on:{"click":_vm.close}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }